import { __rest } from "tslib";
import { extractText, extractSubStepNumberFromSelector, extractNumberOfElements, extractTextContent, } from "./utils/dom";
import { emitComponentRenderedMetric, emitComponentUpdatedMetric, emitFunnelInteractionEvent, emitPerformanceMetric, setFunnelInteractionId, } from "./utils/custom-event";
import { getUuid } from "./utils/uuid";
export function setFunnelMetrics(funnelMetrics) {
    FunnelMetrics = funnelMetrics;
}
export function setPerformanceMetrics(performanceMetrics) {
    PerformanceMetrics = performanceMetrics;
}
export function setComponentMetrics(componentMetrics) {
    ComponentMetrics = componentMetrics;
}
// Holds the current funnel interaction ID used for funnel workflow
let currentFunnelInteractionId;
export let FunnelMetrics = {
    funnelStart(_a) {
        var { funnelNameSelector, funnelIdentifier, funnelInteractionId, componentTheme, currentDocument = document, stepConfiguration, funnelName } = _a, props = __rest(_a, ["funnelNameSelector", "funnelIdentifier", "funnelInteractionId", "componentTheme", "currentDocument", "stepConfiguration", "funnelName"]);
        currentFunnelInteractionId = funnelInteractionId || getUuid();
        // copy of task name displayed to user
        const uxFunnelName = extractTextContent(funnelNameSelector, currentDocument);
        const computedFunnelName = funnelIdentifier || uxFunnelName || funnelName;
        const extractedStepConfiguration = stepConfiguration === null || stepConfiguration === void 0 ? void 0 : stepConfiguration.map((_a) => {
            var { stepIdentifier, name } = _a, rest = __rest(_a, ["stepIdentifier", "name"]);
            return (Object.assign({ name: stepIdentifier || name }, rest));
        });
        // used to track if the current funnel name is service provided one through instanceIdentifier
        const serviceProvidedName = funnelIdentifier ? true : false;
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStart", funnelInteractionId: currentFunnelInteractionId, funnelName: computedFunnelName, uxFunnelName,
                serviceProvidedName, theme: componentTheme, stepConfiguration: extractedStepConfiguration }, props),
        });
        return currentFunnelInteractionId;
    },
    funnelError(_a) {
        var { funnelInteractionId } = _a, props = __rest(_a, ["funnelInteractionId"]);
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelError", funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelComplete(_a) {
        var { funnelInteractionId } = _a, props = __rest(_a, ["funnelInteractionId"]);
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelComplete", funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
        // Set funnel interaction id in Panorama tracker once task is complete
        // to track async alert/flash-bar messages appearing
        setFunnelInteractionId(funnelInteractionId || currentFunnelInteractionId);
    },
    funnelSuccessful(_a) {
        var { funnelInteractionId } = _a, props = __rest(_a, ["funnelInteractionId"]);
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSuccessful", funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelCancelled(_a) {
        var { funnelInteractionId } = _a, props = __rest(_a, ["funnelInteractionId"]);
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelCancelled", funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelChange(_a) {
        var { funnelInteractionId, stepConfiguration } = _a, props = __rest(_a, ["funnelInteractionId", "stepConfiguration"]);
        const extractedStepConfiguration = stepConfiguration === null || stepConfiguration === void 0 ? void 0 : stepConfiguration.map((_a) => {
            var { stepIdentifier, name } = _a, rest = __rest(_a, ["stepIdentifier", "name"]);
            return (Object.assign({ name: stepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelChange", funnelInteractionId: funnelInteractionId || currentFunnelInteractionId, stepConfiguration: extractedStepConfiguration }, props),
        });
    },
    funnelStepStart(_a) {
        var { stepName, stepNameSelector, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
        const extractedStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepStart", stepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelStepComplete(_a) {
        var { stepName, stepNameSelector, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepComplete", totalSubSteps: totalNoOfSubSteps, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelStepError(_a) {
        var { stepName, stepNameSelector, stepErrorSelector, funnelInteractionId, stepIdentifier, errorContext, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["stepName", "stepNameSelector", "stepErrorSelector", "funnelInteractionId", "stepIdentifier", "errorContext", "subStepConfiguration", "currentDocument"]);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedStepError = extractText(stepErrorSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepError", stepError: extractedStepError, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId, errorContext }, props),
        });
    },
    funnelStepNavigation(_a) {
        var { stepNumber, stepNameSelector, stepName, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["stepNumber", "stepNameSelector", "stepName", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepNavigation", originStepNumber: stepNumber, originStepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelStepChange(_a) {
        var { stepName, stepNameSelector, subStepAllSelector = "", totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepChange", stepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelSubStepStart(_a) {
        var { subStepNameSelector, stepNameSelector, stepName, subStepNumber, subStepName, subStepSelector, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["subStepNameSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepName", "subStepSelector", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSubStepStart", subStepName: extractedSubStepName, subStepNumber: extractedSubStepNumber, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelSubStepComplete(_a) {
        var { subStepNumber, subStepNameSelector, subStepName, subStepSelector, stepNameSelector, stepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["subStepNumber", "subStepNameSelector", "subStepName", "subStepSelector", "stepNameSelector", "stepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedSubstepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSubStepComplete", subStepName: extractedSubStepName, subStepNumber: extractedSubstepNumber, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    funnelSubStepError(_a) {
        var { fieldIdentifier, errorContext, fieldLabelSelector, fieldErrorSelector, subStepNumber, subStepSelector, subStepNameSelector, subStepName, stepNameSelector, stepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["fieldIdentifier", "errorContext", "fieldLabelSelector", "fieldErrorSelector", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "stepNameSelector", "stepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
        const fieldName = fieldIdentifier || extractText(fieldLabelSelector, currentDocument);
        const fieldError = extractText(fieldErrorSelector, currentDocument);
        const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSubStepError", subStepName: extractedSubStepName, subStepNumber: extractedSubStepNumber, stepName: extractedStepName, fieldName,
                fieldError,
                errorContext, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    helpPanelInteracted(_a) {
        var { elementSelector, stepNameSelector, stepName, subStepNumber, subStepSelector, subStepNameSelector, subStepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["elementSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedHelpContent = extractTextContent(elementSelector, currentDocument);
        const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "helpPanelInteracted", stepName: extractedStepName, subStepNumber: extractedSubStepNumber, subStepName: extractedSubStepName, helpContent: extractedHelpContent, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
    externalLinkInteracted(_a) {
        var { elementSelector, stepNameSelector, stepName, subStepNumber, subStepSelector, subStepNameSelector, subStepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a, props = __rest(_a, ["elementSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
        const extractedLinkText = extractTextContent(elementSelector, currentDocument);
        const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
        const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
        const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
        const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a) => {
            var { subStepIdentifier, name } = _a, rest = __rest(_a, ["subStepIdentifier", "name"]);
            return (Object.assign({ name: subStepIdentifier || name }, rest));
        });
        emitFunnelInteractionEvent({
            eventInteractionMetaData: Object.assign({ funnelEventType: "externalLinkInteracted", stepName: extractedStepName, subStepNumber: extractedSubStepNumber, subStepName: extractedSubStepName, linkText: extractedLinkText, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
        });
    },
};
/**
 * Method to emit client side performance metrics from Cloudscape components
 */
export let PerformanceMetrics = {
    /**
     * Method to emit Cloudscape table interaction latencies
     * @param {TableInteractionProps} param0
     */
    tableInteraction({ interactionTime, userAction, instanceIdentifier = "", componentIdentifier = "", noOfResourcesInTable = 0, interactionMetadata = "", }) {
        if (interactionTime && interactionTime > 0) {
            const metricName = userAction ? "timeToRespondToTableAction" : "timeToRespondWithoutTableAction";
            emitPerformanceMetric({
                operationalData: {
                    metricList: [
                        {
                            metricName,
                            metricValue: interactionTime,
                            metricUnit: "Milliseconds",
                            metricDetails: JSON.stringify({
                                userAction,
                                instanceIdentifier,
                                componentIdentifier,
                                noOfResourcesInTable,
                                interactionMetadata,
                            }),
                        },
                    ],
                },
                timestamp: Date.now(),
            });
        }
    },
    /**
     * Method to emit Cloudscape modal performance data
     * @param {ModalPerformanceDataProps} param0
     */
    modalPerformanceData({ timeToContentReadyInModal, instanceIdentifier, componentIdentifier, modalMetadata, }) {
        if (timeToContentReadyInModal && timeToContentReadyInModal > 0) {
            const metricName = "timeToContentReadyInModal";
            emitPerformanceMetric({
                operationalData: {
                    metricList: [
                        {
                            metricName,
                            metricValue: timeToContentReadyInModal,
                            metricUnit: "Milliseconds",
                            metricDetails: JSON.stringify({
                                instanceIdentifier,
                                componentIdentifier,
                                modalMetadata,
                            }),
                        },
                    ],
                },
                timestamp: Date.now(),
            });
        }
    },
    /**
     * Method to emit task completion data
     * @param {TaskCompletionDataProps} param0
     */
    taskCompletionData({ timeToRespondAfterFormSubmit, taskIdentifier, taskFlowType, taskType, taskInteractionId, completionMetadata, }) {
        if (timeToRespondAfterFormSubmit && timeToRespondAfterFormSubmit > 0) {
            const metricName = "timeToRespondAfterFormSubmit";
            emitPerformanceMetric({
                operationalData: {
                    metricList: [
                        {
                            metricName,
                            metricValue: timeToRespondAfterFormSubmit,
                            metricUnit: "Milliseconds",
                            metricDetails: JSON.stringify({
                                taskIdentifier,
                                taskFlowType,
                                taskType,
                                taskInteractionId,
                                completionMetadata,
                            }),
                        },
                    ],
                },
                timestamp: Date.now(),
            });
        }
    },
};
export let ComponentMetrics = {
    componentMounted({ taskInteractionId = getUuid(), componentName, componentConfiguration = {} }) {
        emitComponentRenderedMetric({
            eventInteractionMetaData: Object.assign({ componentName, funnelInteractionId: taskInteractionId }, componentConfiguration),
        });
        return taskInteractionId;
    },
    componentUpdated({ taskInteractionId, componentName, actionType, componentConfiguration = {} }) {
        emitComponentUpdatedMetric({
            eventInteractionMetaData: {
                componentName,
                funnelInteractionId: taskInteractionId,
                actionType,
                componentConfiguration,
            },
        });
    },
};
